/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect, useRef } from 'react';
import { userContext } from '../../../../contextProvider/Authentication';
import axiosInstance from '../../../../services/AxiosInstance';
import PreProfile from './PreProfile';
import { handleDatePicker } from '../../../../Functions/apis';
import SimpleReactValidator from 'simple-react-validator';
import swal from 'sweetalert';
import CircleLoader from '../../../../components/CircleLoader';

const ConProfile = ({ stud_id }) => {

    const { user } = useContext(userContext);

    let role = user.role;
    const simpleValidator = useRef(new SimpleReactValidator());

    const [profile, setProfile] = useState();
    const [input, setInput] = useState({});
    const [, forceUpdate] = useState();
    const [loader, setLoader] = useState(false);

    var today = new Date();
    var dateObj = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    dateObj.setDate(dateObj.getDate() - 6600);
    var dob1 = today - new Date(input?.date_of_birth);
    var checkYear = dob1 && Math.floor(dob1 / 31536000000);

    let url = "candidate-profile/";

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        setLoader(true);
        let getlurl = stud_id ? `candidate-profile/?candidate=${stud_id}` : "candidate-profile/"
        axiosInstance(getlurl, { method: "GET" })
            .then(res => {
                setProfile(res?.data?.results?.[0]);
                if (res?.data?.results?.[0]) {
                    let db = res?.data?.results?.[0];
                    db["date_of_birth"] = res?.data?.results?.[0]?.date_of_birth?.split('T')?.[0];
                    setInput(Object.assign({}, db?.user, res?.data?.results?.[0]));
                }
            })
            .catch(err => swal("", Object.values(err?.response?.data), "error", { button: "Ok!", }))
            .finally(() => setLoader(false));
    }


    const handleChange = (e, name, type) => {
        if (['dropdown', 'phone'].includes(type)) {
            setInput({ ...input, [name]: e });
            if (name === 'country') setInput({ ...input, [name]: e, 'state': {}, 'city': {} })
            if (name === 'state') setInput({ ...input, [name]: e, 'city': {} })
        } else {
            setInput({ ...input, [e.target.name]: e.target.value })
            if (e.target.name === 'date_of_birth') {
                setInput({ ...input, [e.target.name]: e.target.value, "age": checkYear });
            }
        }
    }

    function handleSubmit(e) {
        e.preventDefault();
        let formValid = simpleValidator.current.allValid();
        if (!formValid) {
            simpleValidator.current.showMessages();
            forceUpdate(1);
        } else {
            let linput = input;
            linput['country'] = linput?.country?.id;
            linput['state'] = linput?.state?.id;
            linput['city'] = linput?.city?.id;
            linput['gender'] = linput?.gender?.id;
            linput['candidate'] = stud_id ?? user?.id;
            linput['can_type'] = linput?.can_type?.id;
            linput['current_salary'] = linput?.current_salary || null;
            linput['date_of_birth'] = handleDatePicker(new Date(linput?.date_of_birth));
            let method = profile?.id ? "PUT" : "POST";
            let lurl = profile?.id ? `${url}/${linput?.id}/` : url;
            let can_name = { "first_name": linput?.first_name, "last_name": linput?.last_name };
            axiosInstance(`user/${stud_id ?? user?.id}/`, { method: "PATCH", data: can_name });
            axiosInstance(lurl,
                { method: method, data: linput })
                .then(() => {
                    getData();
                    swal("", "Updated successfully", "success", { button: "Ok!", })
                }).catch(err => {
                    console.log('err: ', err.response.data);
                    swal("", Object.values(err.response.data).join(", "), "error", { button: "Ok!", })
                })
        }
    }

    let datas = {
        input,
        handleChange,
        handleSubmit,
        simpleValidator,
        dateObj,
        checkYear,
        role,
        setInput
    }

    if (loader) return <CircleLoader />;

    return (
        <PreProfile {...datas} />
    );
};

export default ConProfile;